import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
body {
    background-color: ${({ theme }) => theme?.body || '#0f1014'} !important;
    color: ${({ theme }) => theme?.text || '#ffffff'};
  }
    #root {background-color: ${({ theme }) => theme?.body || '#0f1014'} !important;
    color: ${({ theme }) => theme?.text || '#ffffff'};
  }
//  button {
//     background-color:${({ theme }) => theme.button} !important;
//     color:${({ theme }) => theme.buttonText} !important;
//   }
 .card {
    border: 1px solid ${({ theme }) => theme.text} !important;
  }
 .page-skeleton {
    background-color:${({ theme }) => theme?.body || '#0f1014'} !important;
  }
 .skeleton {
    background-color:${({ theme }) => theme?.body || '#0f1014'} !important;
  }
 .card-body {
    background-color:${({ theme }) => theme?.body || '#0f1014'} !important;
  }
a{
  color:${({ theme }) => theme?.text || '#ffffff'} !important;
  }
 .theme-text-color {
    color: ${({ theme }) => theme?.text || '#ffffff'} !important;
  }
  .theme-text-color-secondary{
    color: ${({ theme }) => theme?.secondarycolor || '#2d3038'} !important;
  }
  .theme-text-color-body{
    color: ${({ theme }) => theme?.body || '#0f1014'} !important;
  }
  .theme-text-color-button{
    color: ${({ theme }) => theme?.button || '#9b9a9a'} !important;
  }
.theme-bg-color{
    background-color: ${({ theme }) => theme?.body || '#0f1014'} !important;
  }
  .theme-bg-color-secondary{
    background-color: ${({ theme }) => theme?.secondarycolor || '#2d3038'} !important;
  }
  .theme-bg-color-secondary-gradient{
    background: linear-gradient(
  90deg,
  rgb(45, 48, 56) 0%,
  rgb(50, 52, 60) 30%,
  rgba(45, 48, 56, 0.95) 60%,
  rgba(45, 48, 56, 0.85) 100%
) !important;
  }
  .heightForChild{
    background-color: ${({ theme }) => theme.body} !important;
  }
  .theme-bg-color-reverse{
    background-color: ${({ theme }) => theme.text} !important;
  }
  .theme-button-bg-color{
  background-color:${({ theme }) => theme.button} !important;
  }
  .theme-button-bg-secondary-color{
  background-color:${({ theme }) => theme.buttonSecondary} !important;
  }
  .theme-button-text-secondary-color{
  color:${({ theme }) => theme.buttonTextSecondary} !important;
  }
  .theme-button-text-color{
    color:${({ theme }) => theme.buttonText} !important;
  }
   .theme-button-tab-color{
    color:${({ theme }) => theme.button} !important;
  }
  .midHeading2.theme-button-tab-color{
    text-shadow: 3px 3px 6px ${'#0f1014'};
  }
  .custom-slider{
    background-color:${({ theme }) => theme.button} !important;
  }

 
  .bannerMeta label::before {
  color:${({ theme }) => theme.button} !important;
  }
  
  .singleLanguage::before,
  .multiLanguage::before {
  color:${({ theme }) => theme.button} !important;
  }

  .theme-stroke-color{
    stroke:${({ theme }) => theme.button} !important;
 }
  .theme-button-inactive-category{
  background: none!important;
  transition: none !important;
  border:2px solid ${({ theme }) => theme.button};
  }
  .theme-button-active-category{
  border-radius: 50px; 
  font-size: 16px;
  background: ${({ theme }) => theme.button};
  transition: none !important;
  }
  .theme-bg-category-color{
    background-color:#2c2c2c!important;
  }
  .theme-button-bgBorder-color{
  border:1px solid ${({ theme }) => theme.button};
  color:${({ theme }) => theme.button} !important;
  font-size:16px;
  font-weight:500px;
  }
  .theme-button-bgBorder-color-slider{
  border:1px solid ${({ theme }) => theme.button};
  color:${({ theme }) => theme.button} !important;
  font-size:8px;
  line-height:16px;
  font-weight:500px;
  }
  .bgButton{
    background-color:${({ theme }) => theme.button} !important;
    color:${({ theme }) => theme.buttonText} !important;
  }
  .theme-border-body-color{
  border-color: ${({ theme }) => theme.body} !important;
  }
  .theme-border-color{
    border-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  .theme-border-text-color{
  border-color: ${({ theme }) => theme.text} !important;
  }
  .theme-border-button-color{
  border-color: ${({ theme }) => theme.button} !important;
  }
 .theme-border-button-payment{
  border: 1px solid  ${({ theme }) => theme.button} !important;
  }
 .theme-border-button-payment-active{
  border: 4px solid  ${({ theme }) => theme.button} !important;
  }
  .comment-text{
    color:${({ theme }) => theme.button} !important;
  }

  .ott-comment-textarea {
    width: 100%;
    min-height: 110px;
    padding: 16px 20px;
    border-radius: 12px;
    font-size: 15px;
    line-height: 1.6;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    outline: none;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
  .ott-comment-textarea:hover {
    border-color: rgba(255, 255, 255, 0.22) !important;
  }
  .ott-comment-textarea:focus {
    border-color: ${({ theme }) => theme.button} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.button}22 !important;
  }
  .ott-comment-textarea::placeholder {
    opacity: 0.55;
    font-size: 14.5px;
  }

  .ott-reply-input {
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    outline: none;
    transition: all 0.3s ease;
  }
  .ott-reply-input:hover {
    border-color: rgba(255, 255, 255, 0.22) !important;
  }
  .ott-reply-input:focus {
    border-color: ${({ theme }) => theme.button} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.button}22 !important;
  }
  .ott-reply-input::placeholder {
    opacity: 0.55;
  }

  .ott-edit-textarea {
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    outline: none;
    transition: all 0.3s ease;
  }
  .ott-edit-textarea:hover {
    border-color: rgba(255, 255, 255, 0.22) !important;
  }
  .ott-edit-textarea:focus {
    border-color: ${({ theme }) => theme.button} !important;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.button}22 !important;
  }

  .ott-btn-post {
    border-radius: 6px !important;
    padding: 8px 24px !important;
    font-size: 14.5px !important;
    font-weight: 600 !important;
    border: 0 !important;
  }
  .ott-btn-post:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
  }

  .ott-btn-cancel {
    background: transparent !important;
    border-radius: 6px !important;
    padding: 8px 24px !important;
    font-size: 14.5px !important;
    font-weight: 600 !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
  }
  .ott-btn-cancel:hover:not(:disabled) {
    border-color: rgba(255, 255, 255, 0.3) !important;
  }

  .ugc-subscribe-btn {
    border-radius: 6px !important;
    padding: 8px 20px !important;
    font-size: 14.5px !important;
    font-weight: 600 !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    border: 0 !important;
  }
  .ugc-subscribe-btn.subscribed {
    background-color: ${({ theme }) => theme.secondarycolor || 'rgba(255, 255, 255, 0.1)'} !important;
    color: ${({ theme }) => theme.text || '#ffffff'} !important;
  }

 .bootstrapTable table>thead>tr>th{
    border-bottom: 2px solid ${({ theme }) => theme.secondarycolor} !important;
  }
  .bootstrapTable table>tbody>tr{
    border-bottom: 2px solid ${({ theme }) => theme.secondarycolor} !important;
  }
  .drag-border-bottom{
    border-bottom:2px solid #fff;
  }
  .drag-border-bottom-item{
    border-bottom:1px solid #fff;
  }
  .theme-border-secondary{
    border: 2px solid ${({ theme }) => theme.secondarycolor} !important;
  }
  .theme-border-color-reverse{
    border: 1px solid ${({ theme }) => theme.body} !important;
  }
  .theme-border-bottom-secondary{
    border-bottom: 2px solid ${({ theme }) => theme.secondarycolor} !important;
  }
  .custom-placeholder::placeholder{
    color:${({ theme }) => theme.text} !important;
    font-family:"Poppins";
  }
  .bootstrapTable .page-link {
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text};
    border-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .bootstrapTable .active.page-item > .page-link{
    border-color : #0d6efd;
    background-color:#0d6efd;
  }
  .adminHeadContainer .dropdown-item:hover, .adminHeadContainer .dropdown-item:focus{
    background-color: ${({ theme }) => theme.secondarycolor};
  }
  .editdropdown-menu a:hover{
    background-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  .commonActionPadding:hover {
    background-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  input::placeholder{
    color: ${({ theme }) => theme.text} !important;
  }
  .sideMenu.active{A
    background-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  .bannerPopContainer-gradient {
        background: linear-gradient(-50deg, transparent, ${({ theme }) => theme.secondarycolor}) !important;
  }
  .row-custom:hover {
        background: linear-gradient(-50deg, transparent, ${({ theme }) => theme.secondarycolor}) !important;
  }
 
   .simple-hover-overlay {
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.secondarycolor} 0%,
    ${({ theme }) => theme.secondarycolor}CC 50%,
    ${({ theme }) => theme.secondarycolor}00 100%
  );
}

  .bannerLanguageList li:hover {
    background-color:${({ theme }) => theme.button} !important;
     color:${({ theme }) => theme.buttonText} !important;
  }
  .option-card input:checked+.radio-button {
    border-color: ${({ theme }) => theme.button} !important;
    background: radial-gradient(circle, ${({ theme }) => theme.button} 40%, transparent 50%) !important;
  }
  th{
    color: ${({ theme }) => theme.text} !important;
  }
  td{
    color: ${({ theme }) => theme.text} !important;
  }
  .form-select-full-border{
    border: 1px solid ${({ theme }) => theme.text} !important;
  }
  .css-d7l1ni-option{
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .css-1nmdiq5-menu{
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .css-d7l1ni-option:hover{
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .css-1nmdiq5-menu:hover{
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .rti--container{
    background-color: ${({ theme }) => theme.secondarycolor};
    color: ${({ theme }) => theme.text} !important;
    border:0 !important;
  }
  .rti--input{
    background-color: ${({ theme }) => theme.secondarycolor};
    color: ${({ theme }) => theme.text} !important;
  }
  .rti--tag{
    background-color: ${({ theme }) => theme.body} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .css-t3ipsp-control{
    background-color: ${({ theme }) => theme.secondarycolor};
  }
  table{
    --bs-table-bg :  ${({ theme }) => theme.body} !important;
  }
  .theme-text-color-list::after {
    background: ${({ theme }) => theme.text} !important;
  }
  .theme-bg-color-border-right{
    border-right: 1px solid ${({ theme }) => theme.text} !important;
  }
  .play-skip-button-center > * {
  color:${({ theme }) => theme.text} !important
  }
  .spinner{
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top: 3px solid ${({ theme }) => theme.button} !important; 
  border-right: 3px solid${({ theme }) => theme.button} !important; 
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  }
  .custom-fullscreen-button{
   color:${({ theme }) => theme.button} !important
  }
  .my-video-dimensions .vjs-control-bar button {
  color:${({ theme }) => theme.text} !important
  }
  .theme-text-color-bg {
    background-color: ${({ theme }) => theme.text} !important;
  }
  .headingText{
  color: ${({ theme }) => theme.text};
  }
  .theme-button-top-border {
    border-top: 1px solid ${({ theme }) => theme.text} !important
    }
  .theme-button-bottom-border {
    border-bottom: 1px solid ${({ theme }) => theme.text} !important;
    }
  .theme-button-left-border {
    border-left: 1px solid ${({ theme }) => theme.text} !important;
    }
  .theme-border-border-color {
    color: ${({ theme }) => theme.body};
    }
  .theme-border-border-color-all {
    border-bottom: 1px solid ${({ theme }) => theme.text} !important;
    }
  .toggleButton-border{
    border: 1px solid ${({ theme }) => theme.button} !important;
  }
  .bg-image-gradian::before{
    background-image: linear-gradient(to bottom, transparent, ${({ theme }) => theme.secondarycolor}, ${({ theme }) => theme.secondarycolor});
  }
  .linearShadow::before {
  background:linear-gradient(0deg, ${({ theme }) => theme.body} 15%, transparent 40%);
  }

  .rtl  .linearShadow::before{
  background: linear-gradient(270deg, ${({ theme }) => theme.body} 15%, transparent 80%);
  }
  .plan-lineargrade{
  background: linear-gradient(to right, ${({ theme }) => theme.button}, #0000) !important;
  }
  header {
    background-color: ${({ theme }) => theme.body};
  }
  header.sidebar-layout {
    border-bottom: 1px solid ${({ theme }) => theme.text}20 !important;
  }
  a{
    color: ${({ theme }) => theme.text};
  }
  a:hover{
    text-decoration: none;
    color: ${({ theme }) => theme.text};
  }
  div1{
    background-color: ${({ theme }) => theme.body};
  }
  .listChip:hover {
  background-color: ${({ theme }) => theme.body};
  }
  #pageDropDown{
    background-color: ${({ theme }) => theme.body};
    margin-right:13px;
    border: 1px solid ${({ theme }) => theme.secondarycolor} !important;
    color: ${({ theme }) => theme.text} !important;
  }
  .react-bs-table-sizePerPage-dropdown .dropdown-menu {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
  }
  .css-1p3m7a8-multiValue{
    background-color: ${({ theme }) => theme.body} !important;
  }
  .css-wsp0cs-MultiValueGeneric{
    color: ${({ theme }) => theme.text} !important;
  }
  .react-tel-input .country-list .search{
    background-color: ${({ theme }) => theme.body} !important;
  }
  .react-tel-input .country-list .search .search-box{
    background-color: ${({ theme }) => theme.body} !important;
    border: 1px solid ${({ theme }) => theme.text} !important;
  }
  .musicFollowBtn.inActive:hover{
  background-color: ${({ theme }) => theme.secondarycolor} !important;
  color: ${({ theme }) => theme.text} !important;
  }
  .musicHomePageSwiper .swiper-slide:hover, .musicAlbumSwiper .swiper-slide:hover {
  background-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  .purchaseBtn:hover .infoIcon{
  // color: ${({ theme }) => theme.body} !important;
  }
  .custom-shadow{
  box-shadow: 0px 0px 71px -18px  ${({ theme }) => theme.text} !important;
  }
  .shadow-plan-content-plan {
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    box-shadow: 0px 0px 25px -10px ${({ theme }) => theme.text}, 
                0px 5px 20px -5px ${({ theme }) => theme.text}2b !important;
    transition: all 0.3s ease;
  }
  .shadow-plan-content-plan-active {
    border: 3px solid ${({ theme }) => theme.button} !important;
    box-shadow: 0px 15px 35px -8px rgba(0, 0, 0, 0.4), 
                0px 0px 25px -2px ${({ theme }) => theme.button}40 !important;
    transition: all 0.3s ease;
  }
  .progress{
    background-color: ${({ theme }) => theme.secondarycolor} !important;
  }
  .highlighted {
  color: ${({ theme }) => theme.button} !important
  } .highlightfillIcon {
  color: ${({ theme }) => theme.button} !important
  }
  .icontabBg{
  fill:${({ theme }) => theme.button} !important
  }
  .tabHeading.highlightTabColor::after {
    background-color:${({ theme }) => theme.button} !important;
  }
   .my-video-dimensions.vjs-theme-city .vjs-play-progress{
    background-color:${({ theme }) => theme.button} !important;
    }
  .playlistHeading::before{
  background-color:${({ theme }) => theme.button} !important;
  }
  .searchInputHeader::placeholder,.searchInputHeader{
  color: ${({ theme }) => theme.buttonText} !important
  }
  .homeListImage::after { 
    background: linear-gradient(to top, ${({ theme }) => theme.secondarycolor} , transparent);
  }
  // theme two 
.swiperThemeTwo .circleAfter::after, .movieSwiper .circleAfter::after {
    background-color:${({ theme }) => theme.button} !important;
  }
  .themeTwoLink.active::after,.themeTwoLink:hover:after {
  background-color:${({ theme }) => theme.button} !important;
  }
 .partnerSwiper .swiper-pagination-bullet, .movieSwiper .swiper-pagination-bullet{
    background-color:${({ theme }) => theme.text} !important;
  }
   .partnerSwiper .swiper-pagination-bullet-active, .movieSwiper .swiper-pagination-bullet-active{
  background-color:${({ theme }) => theme.button} !important;
  }
.popupDetailsThemeTwo::after {
    background-color: ${({ theme }) => theme.secondarycolor};
  }
 .profileThemeTwo.active{
    background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .profileThemeTwo.active::before{
    background-color:${({ theme }) => theme.button} !important;
  }
  .themeTwoFaq .accordion-button::after {
  background-color:${({ theme }) => theme.text} !important;
  }
  .homeSwiperContainer .dropdown-item:hover,
  .homeSwiperContainer .dropdown-item:focus {
  color:${({ theme }) => theme.button} !important;
  }
  .flickNexsTimeLine{
  background-color:${({ theme }) => theme.body} !important;
  }
  .flickNexsTimeLineMins,.flickNexsSideBar,.timeLineChannelNameHide,.timeLineChannelName,.mainTrack{
  background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .mainTrack::-webkit-scrollbar-track {
    background-color:${({ theme }) => theme.body} !important;
  }
  .mainTrack::-webkit-scrollbar-thumb, .scrollable-desc::-webkit-scrollbar-thumb {
    background-color:${({ theme }) => theme.button} !important;
  }
  .languageDrop  .dropdown-item:hover,  .languageDrop  .dropdown-item:focus{
  background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .hoverEffectSecondary:hover{
  background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .audioBanner::after{
    background-image: linear-gradient(90deg,  ${({ theme }) => theme.body} 35%, transparent);
  }
  .playButton.yes::before{
    background-color:${({ theme }) => theme.button} !important;
  }
  .playButton.one::after{
    color:${({ theme }) => theme.button} !important;
  }
  .avatarProfile.add:hover {
    background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .profileImageUpdateMulti:hover:before{
    background-color: ${({ theme }) => theme.body} !important;
  }
  .secondary:hover{
    background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  .primary:hover{
  background-color:${({ theme }) => theme.body} !important;
  }
  
  .stdropdown-menu{
  background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  // .stdropdown-tools{
  // background-color:${({ theme }) => theme.button} !important;
  // }
  .active.music-link >.musicSideBarIcons{
    color:${({ theme }) => theme.button} !important;
  }
  .loaderFixed{
  background-color:${({ theme }) => theme.secondarycolor} !important;
  }
  input:checked+.custom-slider {
    background-color:${({ theme }) => theme.button} 
  }
  input:focus+.custom-slider {
    box-shadow: 0 0 1px ${({ theme }) => theme.button};
  }

  .custom-slider:before {
    background-color:${({ theme }) => theme.buttonText} 
  }
    .modal-content label {
    color: ${({ theme }) => theme.text} !important;
  }
 .ott-platform::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0 !important;
    background-image: url(${({ settings }) => settings.login_content});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: none !important;
  }
    

  .themeTwoBannerWrappers-bg {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background-color: ${({ theme }) => theme.body} !important;
}

.themeTwoBannerWrappers-bg::before {
    content: "";
    position: absolute;
    top: 0;
    left: -10px;
    right: -10px;
    height: 300px;
    background-image: linear-gradient(0deg, ${({ theme }) => theme.body} 9%, transparent), url(${({ planContent, settings }) => (Number(planContent?.status_plan_background_image) === 1 && planContent?.plan_background_image)});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    filter: blur(3px);
}

/* Mobile - Small phones */
@media (max-width: 480px) {
    .themeTwoBannerWrappers-bg::before {
        height: 300px;
        filter: blur(3px);
    }
}

/* Tablets and larger phones */
@media (min-width: 481px) and (max-width: 768px) {
    .themeTwoBannerWrappers-bg::before {
        
        height: 300px;
        filter: blur(3px);
    }
}

/* Small laptops and tablets landscape */
@media (min-width: 769px) and (max-width: 1024px) {
    .themeTwoBannerWrappers-bg::before {
        
        height: 300px;
        filter: blur(3px);
    }
}

/* Desktops and large screens */
@media (min-width: 1025px) {
    .themeTwoBannerWrappers-bg::before {
        
        height: 300px;
        filter: blur(3px);
    }
}


.wrappertestscrollnew {
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: ${({ theme }) => theme.button} ${({ theme }) => theme.body}; /* For Firefox */
}

.planWrapper::-webkit-scrollbar {
  height: 8px;
}

.planWrapper::-webkit-scrollbar-track {
  background: ${({ theme }) => theme.body};
  border-radius: 10px;
}

.planWrapper::-webkit-scrollbar-thumb {
  background: ${({ theme }) => theme.button};
  border-radius: 10px;
}

.planWrapper::-webkit-scrollbar-thumb:hover {
  background: ${({ theme }) => theme.button};
  opacity: 0.8;
}

.planTable {
  table-layout: auto;
  border-collapse: collapse;
}

.planTable th,
.planTable td {
  word-wrap: break-word;
  overflow-wrap: break-word;
}


.device-platform {
    position: relative;
    overflow: hidden; /* prevents blur overflow */
}

.device-platform::before {
    content: "";
    background-image: url(${({ settings }) => settings.login_content}) !important;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0 !important;
    filter: blur(10px);
    transform: scale(1.1); /* avoid edge clipping from blur */
}

.device-platform::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35); /* slight black tone */
    z-index: 1 !important;
}



.ott-landing-page {
    position: relative;
    overflow: hidden; /* prevents blur overflow */
}

.ott-landing-page::before {
    content: "";
    background-image: url(${({ backgroundImage }) => backgroundImage?.background_image}) !important;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0 !important;
}

.ott-landing-page::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1 !important;
}

@media (max-width: 768px) {
    .ott-landing-page {
        background-attachment: scroll !important;
        background-size: cover !important;
        background-position: center !important;
    }
}

@media (max-width: 768px) {
    .ott-landing-page::before {
        background-image: url(${({ backgroundImage }) => backgroundImage?.mobile_image}) !important;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0 !important;
    }
}

.loader{color: ${({ theme }) => theme.text} !important;}
${({ flimStripe }) => flimStripe === 1 && `.swiperHeading{
      line-height: 28px !important;
    }`}
${({ flimStripe }) => flimStripe === 1 && `.home-section-divider{
      display: none;
    }`}
${({ flimStripe }) => flimStripe === 1 && `.home-section-header{
      margin-bottom: 1rem;
    }`}
${({ flimStripe }) => flimStripe === 1 && `.viewall-homepage{
      border-radius: 50px;
      width: 100px;
      text-align: center;
      background-color: #fff;
      color: #000 !important;
    }`}
.loader:before {
  border-top: 3px solid ${({ theme }) => theme.button} !important;
  border-right: 3px solid ${({ theme }) => theme.button} !important;
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  width: 110%;
  height: 110%;
  border: 3px solid transparent;
  border-radius: 50%;
  animation: animateC 2s linear infinite;
}
#uvf-settings-btn: ${({ theme }) => theme.button} !important }
.loader span:before{background: ${({ theme }) => theme.button} !important }

.letter-btn{
  color: ${({ theme }) => theme.text};
}
.letter-btn.active{
  color: ${({ theme }) => theme.button} !important;
  background-color: ${({ theme }) => theme.text} !important;
}


 @media screen and (max-width: 768px) {
  .themeTwoNavMobileFixed{
    background-color: ${({ theme }) => theme.body} !important;
  }
  .scrollingPlaceholder::placeholder {
    color:${({ theme }) => theme.body} !important;
    }
    ${({ flimStripe }) => flimStripe === 1 && `#search-icon{
      display:none;
    }`}
    ${({ flimStripe }) => flimStripe === 1 && `.viewall-homepage{
      width: 25%;
    }`}
    img.position-relative.d-block.opacity-100.undefined{width: 100% !important}
  }

  ${({ flimStripe }) => flimStripe === 1 && `.swiper-initialized.homePageSwiper, .layoutViewAllPage .layoutViewAllItem{
    --s: 10px;
      background: conic-gradient(at 50% var(--s), #222 75%, #0000 0) 0 0 / calc(2 * var(--s)) calc(100% - var(--s)) padding-box;
      border: var(--s) solid #222;
      padding: 20px 0px !important;
      background-color: transparent !important;
    }
    .homePageSwiper.swiper{overflow: hidden !important;}`}
    
  .sidebar-container {
    background: ${({ theme }) => theme.body} !important;
    border-right: 1px solid ${({ theme }) => theme.text}20 !important;
  }

  .sidebar-item.active {
    border-left: 4px solid ${({ theme }) => theme.button} !important;
    background: ${({ theme }) => theme.secondarycolor} !important;
  }

  .sidebar-item:hover {
    background: ${({ theme }) => theme.secondarycolor} !important;
  }
${({ landscapeSwiper }) => landscapeSwiper === 1 && `
    /* Dynamically reduce swiper slide height for landscape orientation rows */
    .homePageSwiper .swiper-slide { height: auto !important; }
    @media screen and (min-width: 991px) {
      .homePageSwiper .swiper-slide { height: auto !important; }
    }
  `}
`;

